export default function getAnnouncementReturnTarget(container, placement) {
  if (!container) return null;
  const document = container.ownerDocument;
  const candidates = placement === 'modal_bar'
    ? container.closest('.darkModal')?.querySelectorAll('button, a[href], input, [tabindex="0"]') || []
    : document.querySelectorAll('[data-announcement-focus-return]');
  return Array.from(candidates).find((node) => !container.contains(node)
    && !node.disabled
    && !node.closest('[hidden], [inert], [aria-hidden="true"]')
    && node.getClientRects().length > 0
    && document.defaultView.getComputedStyle(node).visibility === 'visible') || null;
}
